import { render, staticRenderFns } from "./ExportLink.vue?vue&type=template&id=6d0fb529&scoped=true"
import script from "./ExportLink.vue?vue&type=script&lang=js"
export * from "./ExportLink.vue?vue&type=script&lang=js"
import style0 from "./ExportLink.vue?vue&type=style&index=0&id=6d0fb529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0fb529",
  null
  
)

export default component.exports